import { RefObject, useCallback, useEffect, useState } from 'react';

export const useKeyboardInputToggle = (inputRef: RefObject<HTMLInputElement>) => {
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  const focusInput = useCallback(() => {
    const el = inputRef.current;
    if (!el) return;

    el.focus();

    try {
      // @ts-expect-error
      navigator.virtualKeyboard?.hide?.();
    } catch {}
  }, [inputRef]);

  const toggleKeyboardInput = useCallback(() => {
    setKeyboardVisible((prev) => {
      const next = !prev;

      window.requestAnimationFrame(() => {
        inputRef.current?.focus();
      });

      return next;
    });
  }, [inputRef]);

  useEffect(() => {
    focusInput();
  }, [focusInput]);

  return { keyboardVisible, toggleKeyboardInput, focusInput };
};
